import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { ReactNode } from 'react';
const renderTooltip = (text: any) => (
    <Tooltip id="tooltip-overflow"  style={{position:"fixed"}}>{text}</Tooltip>
);

const TooltipComponent = ({ text,children }: { text: string ,children: ReactNode }) => {
    return <OverlayTrigger placement="bottom" overlay={renderTooltip(text)}>
        <span
            // className="text-truncate d-inline-block"
            // style={{ maxWidth: '90%' }}
        >
            {children}
        </span>
    </OverlayTrigger>
};
export default TooltipComponent;